import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { TrialBanner } from "@/components/trial-banner";
import { Paywall } from "@/components/paywall";
import { NotificationBell } from "@/components/notification-bell";
import { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";

interface MyCoachData {
  hasCoach: boolean;
  coach: { id: string; firstName: string | null; lastName: string | null } | null;
}

interface LayoutWithSidebarProps {
  children: ReactNode;
  isAdmin?: boolean;
  isCoach?: boolean;
  showNotifications?: boolean;
}

export function LayoutWithSidebar({ children, isAdmin = false, isCoach = false, showNotifications = false }: LayoutWithSidebarProps) {
  const { data: coachData } = useQuery<MyCoachData>({
    queryKey: ["/api/my-coach"],
    staleTime: 5 * 60 * 1000,
  });

  const hasCoach = coachData?.hasCoach || false;

  return (
    <SidebarProvider defaultOpen={true}>
      <AppSidebar isAdmin={isAdmin} isCoach={isCoach} hasCoach={hasCoach} />
      <SidebarInset>
        {showNotifications && (
          <div className="absolute top-3 right-14 md:right-3 z-50">
            <NotificationBell />
          </div>
        )}
        <TrialBanner />
        {children}
      </SidebarInset>
      <Paywall />
    </SidebarProvider>
  );
}
